<template>
<section
  :class="[
    block.class,
    {'half-padding-top': block.half_padding_top},
    {'half-padding-bottom': block.half_padding_bottom},
    'section',
    block.bgcolour
  ]"
  :id="block.anchor ? block.anchor : ('block-' + block.id)"
>
    <div class="container">
        <h2 v-if="block.title" :class="['title', block.title_colour, {'is-hidden': block.hide_title}]">{{block.title}}</h2>
        <search-filter
          v-if="showFilter"
          :HTMLId="block.id"
          :PageId="block.current_page_id"
          :placeholder="`Filter by ${list_is_mobile() ? 'name' : 'title'} or topic...`"
          @on-loading="filterBusy = true"
          @on-loaded="filterBusy = false"
          @on-updated="onFilterUpdated"
        />
        <div class="content" v-if="filterBusy">
          <p class="has-text-centered">just a second...</p>
        </div>
        <div class="content" v-else-if="filterdList && filterdList.list && !filterdList.list.length">
          <p class="has-text-centered">No matching results</p>
        </div>
        <template v-else>
          <div
            v-if="viewItems && viewItems.list.length"
            :class="[
              'view-list',
              {'is-mobile': list_is_mobile()},
              {'columns is-variable is-5 is-multiline': block.list_has_columns}
            ]"
          >
              <template v-if="block.list_has_columns">
                  <div :class="['column', block.grid_size]" v-for="item,i in viewItems.list" :key="i">
                      <component :is="item.type" :item="item" :column_superseded="true" />
                  </div>
              </template>
              <template v-else>
                  <component v-for="item,i in viewItems.list" :key="i" :is="item.type" :item="item" />
              </template>
          </div>
          <div class="cta block-cta" v-if="block.cta && block.cta.button && !all_loaded">
              <div :class="'columns is-mobile is-variable is-' + gap_size()">
                  <div :class="'column ' + block.cta.config.alignment">
                      <template v-if="block.cta_ajax">
                          <button @click.prevent="fetch" :class="['button', {'is-loading': is_loading}, {'is-rounded': block.cta.config.rounded}, block.cta.config.colour, block.cta.config.size]">{{block.cta.button.title}}</button>
                      </template>
                      <template v-else>
                          <CTALink :link_data="block.cta" />
                      </template>
                  </div>
              </div>
          </div>
          <div class="cta block-cta" v-if="viewItems.pages != 1 && all_loaded">
              <div :class="'columns is-mobile is-variable is-' + gap_size()">
                  <div :class="'column ' + block.cta.config.alignment">- All Loaded -</div>
              </div>
          </div>
        </template>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import * as components from './elements'
import SearchFilter from './search/SearchFilter'
export default {
    name        : 'ViewsBlock',
    mixins      : [ BlockCommons ],
    components  : {
      'search-filter': SearchFilter,
      ...components
    },
    data() {
        return {
            filterBusy  : false,
            is_loading  : false,
            page        : 1,
            all_loaded  : this.block.view_items.pages <= 1 && this.block.cta_ajax,
            filterdList : null,
        }
    },
    computed: {
      viewItems() {
        return this.filterdList ? this.filterdList : this.block.view_items
      },
      showFilter() {
        return this.block && this.block.filter_enabled
      }
    },
    methods: {
      onFilterUpdated(list) {
        this.filterBusy = false
        this.filterdList = list
        if (list) {
          this.$el.scrollIntoView({
            behavior: 'smooth',
          })
        }
      },
      gap_size() {
        if (this.block && this.viewItems && this.viewItems.list && this.viewItems.list.length) {
            if (this.viewItems.list[0].type == 'NewsItem') {
                return 2;
            }
        }

        return 6;
      },
      list_is_mobile() {
        if (this.block && this.viewItems && this.viewItems.list && this.viewItems.list.length) {
            return this.viewItems.list[0].type == 'TeamMember';
        }

        return false;
      },
      fetch() {
        if (this.is_loading || this.all_loaded) return false
        this.is_loading =   true;
        axios.get(
            base_url + this.block.cta.button.url.ltrim('/').rtrim('/') + '?page=' + this.page + '&per_load=' + this.block.item_per_page
        ).then((resp) => {
            this.is_loading =   false;
            this.page++;

            if (this.page == resp.data.pages) {
                this.all_loaded =   true;
            }

            let me  =   this;
            resp.data.list.forEach((o) => {
                me.viewItems.list.push(o);
            });
        }).catch((error) => {
            this.is_loading =   false;
        });
      }
    }
}
</script>
<style lang="scss" scoped>
.views-block {
  .view-list {
    > .column {
      @media (max-width: 575px) {
        width: 100% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/ViewsBlock.vue